export enum SubtaskActions {
  Create = 1,
  Update = 2,
  Delete = 3,
  Complete = 4,
}

export const SUBTASK_ACTIONS_LABELS: any = {
  [SubtaskActions.Create]: 'create',
  [SubtaskActions.Update]: 'update',
  [SubtaskActions.Delete]: 'delete',
  [SubtaskActions.Complete]: 'complete',
};
